import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  type CollectionReference,
  type DocumentData,
} from 'firebase/firestore';
import { db } from '../../config';
import { groupStatus } from '../../../../constants/enum';
import type { GroupType } from '../../../../types/group';

/**
 * グループのサブコレクション参照（#2804）
 * companies/{companyId}/groups
 */
export const groupsRef = (companyId: string): CollectionReference<DocumentData> =>
  collection(db, 'companies', companyId, 'groups');

const toGroup = (id: string, data: DocumentData): GroupType => ({
  id,
  name: data.name,
  description: data.description ?? null,
  member_ids: data.member_ids ?? [],
  status: data.status,
  created_at: data.created_at,
  updated_at: data.updated_at,
  created_by: data.created_by,
  updated_by: data.updated_by,
});

/**
 * 企業内の有効なグループ一覧を取得（作成日昇順）
 */
export const getGroups = async (companyId: string): Promise<GroupType[]> => {
  // status の等価条件のみ（自動単一フィールドインデックス）。
  // created_at の並び替えは複合インデックスを避けるためクライアント側で実施（最大50件）。
  const groupQuery = query(groupsRef(companyId), where('status', '==', groupStatus.valid));
  const snapshot = await getDocs(groupQuery);
  return snapshot.docs
    .map(d => toGroup(d.id, d.data()))
    .sort((a, b) => (a.created_at?.toMillis?.() ?? 0) - (b.created_at?.toMillis?.() ?? 0));
};

/**
 * 単一グループを取得
 */
export const getGroup = async (companyId: string, groupId: string): Promise<GroupType | null> => {
  const snapshot = await getDoc(doc(groupsRef(companyId), groupId));
  if (!snapshot.exists()) {
    return null;
  }
  return toGroup(snapshot.id, snapshot.data());
};
